module.exports = __webpack_public_path__ + "img/1.a36fb8c3.gif";